<template>
  <div v-if="condition.items.length > 0">
    <QuantityCheckTable
      :maintenanceId=maintenanceId
      :type=type
      :condition=condition
      @changeCheckbox=changeCheckbox
    >
    </QuantityCheckTable>
    <div class="md-layout md-alignment-top-right mb-4" v-if="!checked">
      <div class="md-layout-item md-size-10">
        <button :id="`finish-btn${condition.id}`" class="btn btn-primary btn-lg btn-block" disabled="disabled" @click="finish">完了</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import QuantityCheckTable from '@/components/parts/QuantityCheckTable';

  export default {
    name: 'QuantityCheck',
    components: {
      QuantityCheckTable,
    },
    computed: {
      ...mapGetters([
        'maintenanceList'
      ]),
      checked: function() {
        if (this.maintenanceId === undefined) return false; // サイドパネルのボタンで遷移した時の対策
        const text = this.type.charAt(0).toUpperCase() + this.type.slice(1);
        const maintenance = Object.values(this.maintenanceList)
          .filter(v => v.maintenanceId === this.maintenanceId)[0];
        return maintenance[`isCheck${text}Quantity${this.condition.id}`];
      },
    },
    props: {
      maintenanceId: Number,
      condition: {},
      type: String,
    },
    methods: {
      finish: function() {
        this.$emit('finish', this.condition.id);
      },
      back: function() {
        this.$emit('back');
      },
      changeCheckbox: function(e, itemId) {
        this.$emit('changeCheckbox', e, this.condition.id, itemId);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/parts/QuantityCheckGroup.vue?4afcc730